export const answerPayload = {
  activity_id: 0,
  activity_question_id: 0,
  question_position: 0,
  type: '',
  answer_essay: '',
  answer_file: [],
  is_next: false,
  is_prev: false,
  is_preview: false
}

export const quizDetail = {
  batch_discussion: 0,
  id: 0,
  instruction: '',
  is_auto_score: 0,
  is_group_question_shuffle: 0,
  is_prev: 0,
  is_question_shuffle: 0,
  is_retake: 0,
  is_refleksi: 0,
  is_show_discussion: 0,
  is_show_point: 0,
  is_show_timer: 0,
  is_skip: 0,
  max_batch: 0,
  maximum_auto_score: 0,
  minimum_score: 0,
  question_per_batch: 0,
  timer_in_seconds: 0,
  title: ''
}

export const quizMasterData = {
  id: 0,
  resource_id: 0,
  title: '',
  instruction: '',
  question_per_batch: 0,
  max_batch: 0,
  timer_in_seconds: 0,
  resource: {
    id: 0,
    order_id: 0,
    chapter_id: 0,
    type: 'quiz',
    title: '',
    description: '',
    url: '',
    content_id: 0,
    question_per_batch: 0,
    is_complete: false,
    periode_start: '',
    from_content: false,
    duration: 0,
    periode_end: '',
    review_date: '',
    is_valid_period: 0,
    bobot_percentage: 0,
    show_comment: 0,
    password: null,
    url_convert: '',
    show_pra_aktivitas: 0,
    pra_aktivitas: '',
    api_key: null,
    assessment_type: 0
  },
  is_skip: 0,
  is_prev: 0,
  is_retake: 0,
  is_show_timer: 0,
  is_show_point: 0,
  is_question_shuffle: 0,
  minimum_score: 0,
  batch_discussion: 0,
  is_group_question_shuffle: 0,
  is_auto_score: 0,
  maximum_auto_score: 0,
  is_show_discussion: 0,
  final_score_format: 'default'
}

export const quizProgramUserData = {
  id: 0,
  pre_test_score: null
}
